import React from 'react';
import VerifyEmail from 'src/components/UI/verifyEmail';

const VerifyEmailPage = () => <VerifyEmail />;

export default VerifyEmailPage;
